import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions';

import 'moment/locale/pt-br.js';
import './VideoTimeline.css';
import 'vis/dist/vis-timeline-graph2d.min.css';
import { Timeline, DataSet } from 'vis/index-timeline-graph2d';

import map from 'lodash/map';
import moment from 'moment';


// Fator para movimentar a timeline: 0.7 significa
// que ao mover a timeline, ela vai andar 70% do
// seu comprimento para o lado.
const MOVE_FACTOR = 0.7;

class VideoTimeline extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentCalendarFilter: {
        index: 7,
        value: moment().startOf('day').valueOf(),
      },
      currentClockFilter: {
        index: 1,
        value: 60,
      },
    }
    this.setTimelineDate = this.setTimelineDate.bind(this);
    this.setTimelineRange = this.setTimelineRange.bind(this);
    this.handleTimelineClick = this.handleTimelineClick.bind(this);
    this.moveTimelineForward = this.moveTimelineForward.bind(this);
    this.moveTimelineBackward = this.moveTimelineBackward.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Ao clicar em uma câmera das "câmeras próximas", o componente
    // é reutilizado com outra câmera.
    if (this.props.camera.id !== prevProps.camera.id) {
      this.props.unregisterTimelineListener(prevProps.camera.vmId, prevProps.camera.id);
      this.setCurrentTime();
    }
    this.updateTimeline();
  }

  componentDidMount() {
    this.updateTimeline();
  }

  componentWillUnmount() {
    if (this.timeline) {
      this.timeline.destroy();
    }
    this.props.unregisterTimelineListener(this.props.camera.vmId, this.props.camera.id);
    this.clearIntervalCurrentTime();
  }

  timelineId() {
    return `timeline-${this.props.camera.id}`;
  }

  updateTimeline() {
    if (!this.props.timeline) return;

    const items = this.buildTimelineItems();
    if (this.timeline && items !== false) {
      this.timeline.setItems(items);
    } else {
      const timelineWindow = this.calculateTimelineWindow();
      const container = document.getElementById(this.timelineId());
      const options = {
        stack: false,
        showMajorLabels: true,
        showCurrentTime: true,
        zoomMin: 300000,
        moveable: false,
        type: 'range',
        start: timelineWindow.start,
        end: timelineWindow.end,
        format: {
          minorLabels: {
            minute: 'HH[h]mm',
            hour: 'HH[h]'
          },
          majorLabels: {
            second: 'DD/MM/YYYY',
            minute: 'DD/MM/YYYY',
            hour: 'DD/MM/YYYY',
          }
        }
      };

      this.timeline = new Timeline(container, items, options);
      this.timeline.on('click', this.handleTimelineClick);
      this.setCurrentTime();

      // Na primeira inicialização do componente
      // essa foi a única forma de fazer ele aparecer
      // corretamente (🔨🔨🔨🔨🔨)
      setTimeout(() => this.timeline.redraw(), 500);
    }
  }

  buildTimelineItems() {
    if (this.props.timeline.timeline.length == 0) {
      return false;
    }
    const items = map(this.props.timeline.timeline[0].timeline, this.timelineToVisItem);
    return new DataSet(items);
  }

  timelineToVisItem(timeline) {
    const start = moment(timeline.start * 1000);
    return {
      start: start.toDate(),
      end: start.add(timeline.duration, 'seconds').toDate(),
      content: ''
    };
  }

  setTimelineDate(e) {
    this.setState({
      currentCalendarFilter: {
        index: parseInt(e.target.dataset.index, 10),
        value: parseInt(e.target.dataset.date, 10)
      }
    }, this.setTimelineWindow);
  }

  setTimelineRange(e) {
    this.setState({
      currentClockFilter: {
        index: parseInt(e.target.dataset.index, 10),
        value: parseInt(e.target.dataset.range, 10)
      }
    }, this.setTimelineWindow);
  }

  calculateTimelineWindow() {
    const baseDate = moment(this.state.currentCalendarFilter.value);
    const timeRange = this.state.currentClockFilter.value;
    let start, end;
    const isToday = baseDate.isSame(new Date(), 'day');
    if (isToday) {
      end = moment().add(timeRange * 0.1, 'minutes').valueOf();
      start = moment().subtract(timeRange, 'minutes').valueOf();
    } else {
      start = baseDate.valueOf();
      end = baseDate.add(timeRange, 'minutes').valueOf();
    }
    return { start, end };
  }

  setTimelineWindow() {
    const timelineWindow = this.calculateTimelineWindow();
    this.timeline.setWindow(timelineWindow.start, timelineWindow.end, {
      animation: true
    });
  }

  handleTimelineClick(event) {
    if (event.what === 'item') {
      const secondsAgo = moment().unix() - event.snappedTime.unix();
      const url = this.props.camera.videoUrl.replace('.m3u8', `_dvr_timeshift-${secondsAgo}.m3u8`);
      this.props.updateVideoUrl(url);
      this.setCurrentTime(event.snappedTime);
    } else if (event.what === 'background') {
      const itemsRange = this.timeline.getItemRange();
      const clicouDepoisDaBarra = moment(itemsRange.max).unix() - event.snappedTime.unix() < 0;
      if (clicouDepoisDaBarra) {
        this.setCurrentTime();
        this.props.updateVideoUrl(this.props.camera.videoUrl);
      }
    }
  }

  moveTimelineForward() {
    this.moveTimeline(this.state.currentClockFilter.value * MOVE_FACTOR);
  }

  moveTimelineBackward() {
    this.moveTimeline(this.state.currentClockFilter.value * -MOVE_FACTOR);
  }

  moveTimeline(minutes) {
    const currentWindow = this.timeline.getWindow();
    const newStart = moment(currentWindow.start).add(minutes, 'minutes');
    const newEnd = moment(currentWindow.end).add(minutes, 'minutes');
    this.timeline.setWindow(newStart, newEnd, { animation: true });
  }

  setCurrentTime(dateObj) {
    this.clearIntervalCurrentTime();

    const currentTime = moment(dateObj);
    this.timeline.setCurrentTime(currentTime);
    const currentTimeBar = document.querySelector('.vis-current-time');
    if (currentTimeBar) {
      currentTimeBar.dataset.content = currentTime.format('HH:mm');
    }

    this.intervalId = setInterval(() => {
      const timeBar = document.querySelector('.vis-current-time');
      if (timeBar) {
        timeBar.dataset.content = currentTime.add(1, 'second').format('HH:mm');
      }
    }, 1000);
  }

  clearIntervalCurrentTime() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  render() {
    return (
      <div className="timeline" style={ { display: this.props.timeline ? 'block' : 'none' } }>
        <div className="timeline-filter">
          { this.renderCalendarOptions() }
          { this.renderClockOptions() }
        </div>
        <div className="timeline-view">
          <div className="timeline-control move-forward" onClick={ this.moveTimelineBackward }><i className="fa fa-angle-left"></i></div>
          <div className="timeline-element" id={ this.timelineId() }></div>
          <div className="timeline-control move-backward" onClick={ this.moveTimelineForward }><i className="fa fa-angle-right"></i></div>
        </div>
      </div>
    );
  }

  renderCalendarOptions() {
    const firstBadge = moment().startOf('day').subtract(7, 'days');
    const badges = [];
    for (let i = 0; i < 8; i++) {
      const isActive = this.state.currentCalendarFilter.index === i;
      const badgeLabel = i === 7 ? 'HOJE' : firstBadge.format('ddd');
      badges.push(<span key={i} data-index={i} className={ `badge badge-default ${isActive ? 'active' : ''}` } data-date={ firstBadge.valueOf() } onClick={ this.setTimelineDate }>{ badgeLabel }</span>);
      firstBadge.add(1, 'days');
    }
    return (
      <div className="options-calendar">
        <span className="calendar-icon"><i className="fa fa-calendar"></i></span>
        { badges }
      </div>
    );
  }

  renderClockOptions() {
    const badges = [];
    const times = [1440, 60, 5]
    const labels = ['24H', '1H', '5MIN'];
    for (let i = 0; i < 3; i++) {
      const isActive = this.state.currentClockFilter.index === i;
      badges.push(<span key={i} data-index={i} className={ `badge badge-default ${isActive ? 'active' : ''}` } data-range={ times[i] } onClick={ this.setTimelineRange }> { labels[i] } </span>);
    }
    return (
      <div className="options-clock">
        <span className="clock-icon"><i className="fa fa-clock-o"></i></span>
        { badges }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  timeline: state.currentTimeline,
  videoUrl: state.videoUrl,
});
const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VideoTimeline);



// WEBPACK FOOTER //
// ./src/components/VideoTimeline.js